import { Component } from "preact";
import PropTypes from "prop-types";
import { route } from "preact-router";
import { E_Route } from "../../models/constants/Enum_Routes";
import { Debouncer, Jiffy } from "@green24/npm-javascript-utils";
import { APP_CONSTANTS } from "../../models/constants/AppConstants";
import { AppUtils } from "../../utils/AppUtils";
import withConfiguration from "../shared/hoc/withConfiguration";
import { ValueUpdateListeners } from "@green24/npm-preact-utils";

class IdleTimeout extends Component {
	constructor(props) {
		super(props);

		this._debouncer = new Debouncer(1000);

		this._idleTimeout = null;
		this._lastValue = Jiffy.formatToMs(props.configuration?.redirectTimeout);
		this._lastInteraction = Date.now();
		this._valueUpdateListeners = new ValueUpdateListeners(this);
	}

	componentDidMount() {
		this._valueUpdateListeners.add("props.idleTimeout", value => this._registerTimeout(Jiffy.formatToMs(value)));

		this._registerTimeout(this.props.configuration?.redirectTimeout ?? 0);

		window.addEventListener("mouseup", () => {
			window.lastInteraction = new Date();
			this._registerTimeout();
		});
		document.addEventListener('contextmenu', () => {
			window.lastInteraction = new Date();
			this._registerTimeout();
		});
		window.addEventListener("touchmove", () => {
			window.lastInteraction = new Date();
			this._debounceTimeout();
		});
		window.addEventListener("mousemove", () => {
			window.lastInteraction = new Date();
			this._debounceTimeout();
		});
		window.addEventListener("scroll", () => {
			window.lastInteraction = new Date();
			this._debounceTimeout();
		});
		window.addEventListener("mousewheel", () => {
			window.lastInteraction = new Date();
			this._debounceTimeout();
		});
		window.addEventListener(APP_CONSTANTS.LOCAL_STORAGE_NO_REDIRECT_EVENT_NAME, () => this._registerTimeout());
	}

	componentDidUpdate(previousProps, previousState, snapshot) {
		this._valueUpdateListeners.componentDidUpdate(previousProps, previousState);
	}

	render() {
		return null;
	}

	_debounceTimeout() {
		this._debouncer.trigger(() => this._registerTimeout())
	}

	_registerTimeout(time = this._lastValue) {
		if(AppUtils.isDev && localStorage.getItem("noRedirect")) {
			clearTimeout(this._idleTimeout);
			return;
		}

		this._lastInteraction = Date.now();
		//Notify that the user has interacted with the display
		window.dispatchEvent(new Event(APP_CONSTANTS.IDLE_RESET));

		clearTimeout(this._idleTimeout);
		if(time > 0) {
			//Debug
			if(AppUtils.isDev && localStorage.getItem("logIdleTimeoutChange")) {
				console.log(`Timeout set to ${Jiffy.readableDuration(time)} (${time}ms)`);
			}

			this._idleTimeout = setTimeout(() => {
				route(E_Route.BASE);

				//Notify that the display was inactive
				window.dispatchEvent(new CustomEvent("idle-redirect", {
					detail: {
						waitedFor: time,
						lastInteraction: this._lastInteraction,
					}}));
			}, time);

			this._lastValue = time;
		}
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			//withConfiguration
			configuration: PropTypes.object,
		}
	}
}

export default withConfiguration(IdleTimeout);
